"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ErrorType;
(function (ErrorType) {
    ErrorType[ErrorType["AcornParseError"] = 0] = "AcornParseError";
    ErrorType[ErrorType["CallingNonFunctionValues"] = 1] = "CallingNonFunctionValues";
    ErrorType[ErrorType["DeclaratorNotIdentifier"] = 2] = "DeclaratorNotIdentifier";
    ErrorType[ErrorType["IfAlternateNotABlockStatement"] = 3] = "IfAlternateNotABlockStatement";
    ErrorType[ErrorType["IfConsequentNotABlockStatement"] = 4] = "IfConsequentNotABlockStatement";
    ErrorType[ErrorType["MatchFailure"] = 5] = "MatchFailure";
    ErrorType[ErrorType["MissingIfAlternate"] = 6] = "MissingIfAlternate";
    ErrorType[ErrorType["MissingSemicolon"] = 7] = "MissingSemicolon";
    ErrorType[ErrorType["TrailingComma"] = 8] = "TrailingComma";
    ErrorType[ErrorType["UndefinedVariable"] = 9] = "UndefinedVariable";
    ErrorType[ErrorType["UseStrictEquality"] = 10] = "UseStrictEquality";
    ErrorType[ErrorType["UseStrictInequality"] = 11] = "UseStrictInequality";
    ErrorType[ErrorType["VariableRedeclaration"] = 12] = "VariableRedeclaration";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
//# sourceMappingURL=errorTypes.js.map


//////////////////
// WEBPACK FOOTER
// ../source-toolchain/es5/errorTypes.js
// module id = 65
// module chunks = 3